import { English, Hindi, Italian, Portugese, Spanish } from './Text'

// Using https://github.com/mobileposse/locationapi
export const settings = {
  blockConfig: {
    api: {
      location: {
        sandbox: 'https://location-api.sandbox.mobileposse.com/api/3.0/location/accuweather/',
        live: 'https://location-api.mobileposse.com/api/3.0/location/accuweather/'
      },
      weatherCurrent: {
        sandbox: 'https://location-api.sandbox.mobileposse.com/api/3.0/weather/accuweather/current/',
        live: 'https://location-api.mobileposse.com/api/3.0/weather/accuweather/current/'
      },
      weatherDaily: {
        sandbox: 'https://location-api.sandbox.mobileposse.com/api/3.0/weather/accuweather/daily/',
        live: 'https://location-api.mobileposse.com/api/3.0/weather/accuweather/daily/'
      }
    },
    chrome_tab: 1,
    tracking_string: '?sourceProviderId=dt'
  },
  icon_path: `https://images.cm.digitalturbine.com/neptune/weather/icons`
}

export const textLangMap = lang => {
  switch (lang) {
    case 'es':
      return Spanish
    case 'pt':
      return Portugese
    case 'hi':
      return Hindi
    case 'es-mx':
      return Spanish
    case 'it':
      return Italian
    default:
      return English
  }
}

export const langMap = lang => {
  switch (lang) {
    case 'es':
    case 'es-mx':
      return 'es'
    default:
      return 'en'
  }
}
